import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {TaskDataService} from '../service/task-data.service';
import {ComponentHelper} from '../helper/component.helper';

@Injectable()
export class DataTypeResolver implements Resolve<unknown> {

    constructor(private readonly taskDataService: TaskDataService) {
    }

    public resolve(route: ActivatedRouteSnapshot): unknown {
        const dataType = ComponentHelper.getNutzdatenPath(route);
        return this.taskDataService.getNutzdaten(dataType);
    }
}
